import { FacetGroupSelect } from "./FacetGroupSelect";
import tracker from "../tracking/Tracker";
import { isActive } from "../toggle/Toggle";
import { listFeatures, submitActionTrackingFrom } from "../tracking/FeatureTracking";
import type { TrackingLabels } from "../tracking/TrackingLabels";

export class FacetGroupSelectAction implements EventListenerObject {
  /*               */
  constructor(
    readonly select: FacetGroupSelect,
    private readonly initialFacetGroup = select.selectedOption?.value,
  ) {}

  /*                  */

  static on(select: FacetGroupSelect, listener = new FacetGroupSelectAction(select)) {
    select.select.addEventListener("change", listener, {
      passive: true,
    });
    select.select.form?.addEventListener("reset", listener, {
      passive: true,
    });
  }

  /*                  */

  handleEvent(event: Event) {
    if (event.target instanceof HTMLSelectElement) {
      const facetGroup = event.target.value;
      const updated = this.select.activateFacetGroup(facetGroup);

      if (updated) {
        const labels: Partial<TrackingLabels> = {
          san_DefaultFacetChange: facetGroup,
          san_DefaultFacet: this.initialFacetGroup || "none",
        };
        if (isActive("HEUREKA_2004_IMPROVE_VISIBILITY_TRACKING")) {
          this.select.facetGroups.forEach((group) => {
            if (group.active) {
              /*                                                     */
              /*                                                                                             */
              group.updateChildrenFeatureStatus("loaded", "visible");
              submitActionTrackingFrom(group.facetGroup, "open", labels, [
                ...listFeatures(["Filter-Overview"]),
                ...listFeatures(["Filter"], undefined, `[id="${this.select.select.form.id}"]`),
              ]);
            } else {
              group.updateChildrenFeatureStatus("visible", "loaded");
            }
          });
        } else {
          tracker.submitEvent(labels);
        }
      }
    } else {
      /*              */
      this.select.activateFacetGroup(this.initialFacetGroup);
    }
  }
}
